import { component } from 'picoapp';
import Swiper, { Navigation, Pagination, Keyboard } from 'swiper';

export default component((node, ctx) => {
  const swiper = new Swiper('.swiper', {
    modules: [Navigation, Pagination, Keyboard],
    spaceBetween: 0,
    keyboard: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      renderBullet: function (index, className) {
        const activeSlides = this.slides.filter((slide) => slide.classList.contains('is-active'));
        
        if (activeSlides[index].querySelector('deferred-media') != null){ 
          const classVideoBullet = ' pagination-video-bullet';
          return '<span class="' + className + classVideoBullet + `">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" width="82" height="105" viewBox="0 0 82 105" fill="none">
                <path d="M1.90019 1.29983L80.8232 53.3474L0.610874 103.385L1.90019 1.29983Z"/>
            </svg>
          </span>`;
        }
        return '<span class="' + className + '"></span>';
      },
    },
    on: {
      slideChange: function () {
        const activeSlides = this.slides.filter((slide) => slide.classList.contains('is-active'));
        const deferredMedia = activeSlides[this.activeIndex].querySelector('deferred-media');
        if(deferredMedia != null && deferredMedia.getAttribute("loaded") != 'true' && deferredMedia.dataset.video == 'true'){
          deferredMedia.loadContent();
        }
      },
    },
  });

  const giftYes = node.querySelector('.js-gift-yes');
  const giftNo = node.querySelector('.js-gift-no');
  const note = node.querySelector('.js-add-note');
  const textarea = node.querySelector('.js-gift-textarea');

  giftYes.addEventListener('click', () => {
    giftYes.classList.add('is-active');
    giftNo.classList.remove('is-active');
    note.classList.remove('hidden');
    textarea.focus();
  });

  giftNo.addEventListener('click', () => {
    giftYes.classList.remove('is-active');
    giftNo.classList.add('is-active');
    note.classList.add('hidden');
  });
});
